import React from "react";
import Banner from "../../components/Banner";
import IntroductionContent from "../../components/IntroductionContent";
import ResetPasswordContent from "./parts/Content";

export default function ResetPassword() {
    return (
        <section className="register">
            <Banner component={<ResetPasswordContent />} />

            <IntroductionContent />
        </section>
    );
}
